/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

export type ListRiskPolicyApprovalsSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListRiskPolicyApprovalsSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListRiskPolicyApprovalsSecurity = {
  option1?: ListRiskPolicyApprovalsSecurityOption1 | undefined;
  option2?: ListRiskPolicyApprovalsSecurityOption2 | undefined;
};

/**
 * Optional status filter. An open request past its window counts as expired.
 */
export const Status = {
  Blocked: "blocked",
  Pending: "pending",
  Approved: "approved",
  Denied: "denied",
  Consumed: "consumed",
  Expired: "expired",
} as const;
/**
 * Optional status filter. An open request past its window counts as expired.
 */
export type Status = ClosedEnum<typeof Status>;

export type ListRiskPolicyApprovalsRequest = {
  /**
   * Optional status filter. An open request past its window counts as expired.
   */
  status?: Status | undefined;
  /**
   * Continue after this approval request ID.
   */
  cursor?: string | undefined;
  /**
   * Maximum number of requests to return.
   */
  limit?: number | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListRiskPolicyApprovalsSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListRiskPolicyApprovalsSecurityOption1$outboundSchema:
  z.ZodMiniType<
    ListRiskPolicyApprovalsSecurityOption1$Outbound,
    ListRiskPolicyApprovalsSecurityOption1
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function listRiskPolicyApprovalsSecurityOption1ToJSON(
  listRiskPolicyApprovalsSecurityOption1:
    ListRiskPolicyApprovalsSecurityOption1,
): string {
  return JSON.stringify(
    ListRiskPolicyApprovalsSecurityOption1$outboundSchema.parse(
      listRiskPolicyApprovalsSecurityOption1,
    ),
  );
}

/** @internal */
export type ListRiskPolicyApprovalsSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListRiskPolicyApprovalsSecurityOption2$outboundSchema:
  z.ZodMiniType<
    ListRiskPolicyApprovalsSecurityOption2$Outbound,
    ListRiskPolicyApprovalsSecurityOption2
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listRiskPolicyApprovalsSecurityOption2ToJSON(
  listRiskPolicyApprovalsSecurityOption2:
    ListRiskPolicyApprovalsSecurityOption2,
): string {
  return JSON.stringify(
    ListRiskPolicyApprovalsSecurityOption2$outboundSchema.parse(
      listRiskPolicyApprovalsSecurityOption2,
    ),
  );
}

/** @internal */
export type ListRiskPolicyApprovalsSecurity$Outbound = {
  Option1?: ListRiskPolicyApprovalsSecurityOption1$Outbound | undefined;
  Option2?: ListRiskPolicyApprovalsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListRiskPolicyApprovalsSecurity$outboundSchema: z.ZodMiniType<
  ListRiskPolicyApprovalsSecurity$Outbound,
  ListRiskPolicyApprovalsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListRiskPolicyApprovalsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListRiskPolicyApprovalsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listRiskPolicyApprovalsSecurityToJSON(
  listRiskPolicyApprovalsSecurity: ListRiskPolicyApprovalsSecurity,
): string {
  return JSON.stringify(
    ListRiskPolicyApprovalsSecurity$outboundSchema.parse(
      listRiskPolicyApprovalsSecurity,
    ),
  );
}

/** @internal */
export const Status$outboundSchema: z.ZodMiniEnum<typeof Status> = z.enum(
  Status,
);

/** @internal */
export type ListRiskPolicyApprovalsRequest$Outbound = {
  status?: string | undefined;
  cursor?: string | undefined;
  limit: number;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListRiskPolicyApprovalsRequest$outboundSchema: z.ZodMiniType<
  ListRiskPolicyApprovalsRequest$Outbound,
  ListRiskPolicyApprovalsRequest
> = z.pipe(
  z.object({
    status: z.optional(Status$outboundSchema),
    cursor: z.optional(z.string()),
    limit: z._default(z.int(), 50),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listRiskPolicyApprovalsRequestToJSON(
  listRiskPolicyApprovalsRequest: ListRiskPolicyApprovalsRequest,
): string {
  return JSON.stringify(
    ListRiskPolicyApprovalsRequest$outboundSchema.parse(
      listRiskPolicyApprovalsRequest,
    ),
  );
}
